// extracted by mini-css-extract-plugin
export default {"alert":"englishWebsiteAlert_alert__slxYz"};